import { defineComponent as _defineComponent } from 'vue'
import type { ThumborImage } from '@/filters/thumbor';
import type { ImageProp } from '@/helpers/picture-comp-helper';

import PictureCompHelper from '@/helpers/picture-comp-helper';

import { computed } from 'vue';
import { PosterSponsoredRecImages } from '@/interfaces/components/poster/PosterGraphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'PictureComp',
  props: {
    imageProfile: null,
    alt: { default: '' },
    imageUrl: { default: '' },
    fadeIn: { type: Boolean, default: false },
    slug: { default: '' },
    lazy: { type: Boolean, default: true },
    loading: { default: 'eager' },
    fetchpriority: { default: 'auto' },
    sponsoredRecImages: { default: null },
    imagePropFilter: { default: () => ['avif', 'webp', 'jpeg'] },
    defaultImageFormat: null,
    imageProps: { default: undefined },
    objectPositionTop: { type: Boolean, default: false }
  },
  emits: ["imageLoad", "imageError"],
  setup(__props: any) {

const props = __props as { imageProfile: keyof ThumborImage<any>, alt: string, imageUrl: string, fadeIn: boolean, slug: string, lazy: boolean, loading: 'eager' | 'lazy', fetchpriority: 'high' | 'auto', sponsoredRecImages: PosterSponsoredRecImages | null, imagePropFilter: string[], defaultImageFormat?: 'avif' | 'webp' | 'jpeg', imageProps: Record<string, ImageProp> | undefined, objectPositionTop: boolean };





const defaultImageUrl = computed(() => {
	if (props.sponsoredRecImages?.imageUrl) {
		return props.sponsoredRecImages.imageUrl;
	}

	return PictureCompHelper.getDefaultImageUrl(
		props.imageUrl,
		props.imageProfile,
		props.slug,
		props.defaultImageFormat
	);
});

const sourceSets = computed(() => {
	if (props.sponsoredRecImages?.sourceSets) {
		return props.sponsoredRecImages.sourceSets;
	}

	return PictureCompHelper.getSourceSetImages(
		props.imageUrl,
		props.imageProfile,
		props.slug,
		props.imagePropFilter,
		props.imageProps
	);
});

return { __sfc: true,props, defaultImageUrl, sourceSets }
}

})